"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var rich_text_types_1 = require("@contentful/rich-text-types");

var rich_text_react_renderer_1 = require("@contentful/rich-text-react-renderer");

var LIRenderer_1 = require("./renderers/node/LIRenderer/LIRenderer");

var EntryLinkRenderer_1 = require("./renderers/node/EntryLinkRenderer/EntryLinkRenderer");

var HyperlinkRenderer_1 = require("./renderers/node/HyperlinkRenderer/HyperlinkRenderer");

var PlainTextRenderer_1 = require("./renderers/text/PlainTextRenderer/PlainTextRenderer");

var util_1 = require("./renderers/util");

exports.defaultRendererOptions = {
  renderNode: (_a = {}, _a[rich_text_types_1.BLOCKS.HEADING_1] = util_1.h1Renderer, _a[rich_text_types_1.BLOCKS.HEADING_2] = util_1.h2Renderer, _a[rich_text_types_1.BLOCKS.HEADING_3] = util_1.h3Renderer, _a[rich_text_types_1.BLOCKS.HEADING_4] = util_1.h4Renderer, _a[rich_text_types_1.BLOCKS.HEADING_5] = util_1.h5Renderer, _a[rich_text_types_1.BLOCKS.PARAGRAPH] = util_1.paragraphRenderer, _a[rich_text_types_1.BLOCKS.UL_LIST] = util_1.unorderedListRenderer, _a[rich_text_types_1.BLOCKS.OL_LIST] = util_1.orderedListRenderer, _a[rich_text_types_1.BLOCKS.LIST_ITEM] = LIRenderer_1.renderListItem, // NOTE(benjamin): In case it's needed at some point, there's also a
  // reference implementation of an embedded asset hyperlink renderer:
  // [INLINES.ASSET_HYPERLINK]: renderAssetLink,
  _a[rich_text_types_1.INLINES.ENTRY_HYPERLINK] = EntryLinkRenderer_1.renderEntryLink, _a[rich_text_types_1.INLINES.HYPERLINK] = HyperlinkRenderer_1.renderHyperlink, _a),
  renderText: PlainTextRenderer_1.renderPlainText,
  renderMark: {}
};

function mergeDefaultOptionsWith(options) {
  if (!options) {
    return exports.defaultRendererOptions;
  }

  return {
    renderNode: __assign(__assign({}, exports.defaultRendererOptions.renderNode), options.renderNode),
    renderText: options.renderText || exports.defaultRendererOptions.renderText,
    renderMark: __assign(__assign({}, exports.defaultRendererOptions.renderMark), options.renderMark)
  };
}

exports.mergeDefaultOptionsWith = mergeDefaultOptionsWith;

exports.ContentfulRichTextRenderer = function (_a) {
  var content = _a.content,
      options = _a.options;

  if (!content) {
    return null;
  }

  var realOptions = mergeDefaultOptionsWith(options);
  return React.createElement(React.Fragment, null, rich_text_react_renderer_1.documentToReactComponents(content, realOptions));
};